<div class="m-modal"
     ref="baseWindow">
    <slot name="trigger"></slot>
    <portal :target-el="portalTargetSelector"
            v-if="portalCreated">
        <transition name="m--is">
            <div v-show="propOpen"
                 v-if="portalMounted"
                 class="m-modal__wrap"
                 :class="[{ 'm--is-small': sizeSmall,
                            'm--is-large': sizeLarge,
                            'm--is-full-screen': sizeFullSceen,
                            'm--has-body-max-width': bodyMaxWidth,
                            'm--is-close-on-backdrop': closeOnBackdrop,
                            'm--is-disabled':disabled }, className ]"
                 @click.self="backdropClick()"
                 ref="modalWrap">
                <article class="m-modal__article"
                         ref="article"
                         role="dialog"
                         aria-modal="true"
                         :aria-labelledby="titleId"
                         tabindex="-1">
                    <header class="m-modal__header" >
                        <h2 v-if="title" :id="titleId">{{ title }}</h2>
                        <slot name="header" />
                        <slot name="header-bouton">
                            <m-icon-button icon-name="m-svg__close-clear"
                                           skin="dark"
                                           class="m-modal__close-button"
                                           :title="closeTitle"
                                           @click="closeModal()" />
                        </slot>
                    </header>
                    <div ref="body"
                         class="m-modal__body"
                         :class="{ 'm--has-no-padding': !paddingBody }">
                        <slot />
                    </div>
                    <footer v-if="$slots.footer"
                            class="m-modal__footer">
                        <slot name="footer" />
                    </footer>
                </article>
            </div>
        </transition>
    </portal>
</div>
